<template>
  <v-card>
    <v-card-title class="pt-0">
      Unternehmensinformationen
    </v-card-title>
    <v-card-text>
      <v-alert
        :value="alert_succ"
        color="success"
        dark
        border="top"
        icon="mdi-home"
        transition="slide-y-transition"
        style="position: fixed;
          right: 5%;
          top: 150px;
          transform: translate(-50%, -50%);
          margin: 0 auto;"
      >
        Daten erfolgreich gespeichert.
      </v-alert>

      <v-alert
        :value="alert_warn"
        color="warning"
        dark
        border="top"
        icon="mdi-home"
        transition="slide-y-transition"
        style="position: fixed;
          right: 5%;
          top: 150px;
          transform: translate(-50%, -50%);
          margin: 0 auto;"
      >
        Debitor konnte nicht gespeichert werden.
      </v-alert>
      <v-container>
        <v-row>
          <v-col cols="3">
            <v-text-field v-model="apiDataBranche" label="Branche | AI" />
            <v-text-field v-model="apiDataMitarbeiter" label="Mitarbeiteranzahl | AI" />
          </v-col>
          <v-col cols="6">
            <v-textarea
              v-model="apiDataInfoText"
              outlined
              label="Infotext"
            />
          </v-col>
          <v-col cols="1">
            <v-btn color="primary" @click="refresch">
              AI Suche
            </v-btn>
          </v-col>
          <v-col cols="2">
            <v-btn color="primary" @click="save">
              speichern
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
   props: {
      customer: {
         type: Object,
         required: true,
      },
   },

   data () {
      return {
         tab: 0,
         dialog: false,
         customerInfo: {},
         alert_succ: false,
         alert_warn: false,
         apiDataBranche: '',
         apiDataMitarbeiter: '',
         apiDataInfoText: '',
      }
   },
   mounted: function () {
      this.loadCustomer()
      //   this.loadAiApi()
   },
   methods: {
      save () {
         this.saveKundeApi()
      },
      refresch () {
         this.loadAiApi()
      },
      loadCustomer () {
         fetch(this.route('customer.info', {
            customer: this.customer.id
         }))
            .then(response => response.json())
            .then((data) => this.baseLoad(data))
      },
      baseLoad (data) {
         this.customerInfo = data
         this.loadKundeApi()
      },
      async loadAiApi () {
         let adressSTring = ''
         const test = this.customerInfo?.branches[0]?.address
         if (test) {
            adressSTring += encodeURIComponent(`${test?.street} ${test?.house_number}, ${test?.zip} ${test?.city}`)
         }

         const firmenName = encodeURIComponent(this.customerInfo.name)
         const response = await fetch(`/ai/refresh?Firma=${firmenName}&Ort=${adressSTring}`, {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
               Authorization: `Basic ${window.btoa('KIDaten:KIDaten123.,')}`,
            },
         })
         if (!response.ok) {
            throw new Error(`Response status: ${response.status}`)
         }

         const json = await response.json()
         if (json.constructor === Array) {
            if (0 in json) {
               const item = json[0]
               //  let template = ''
               for (const [key, value] of Object.entries(item)) {
                  if (key === 'Branche' || key === 'branche') {
                     this.apiDataBranche = value
                  }
                  if (key === 'Arbeitnehmerzahl' || key === 'arbeitnehmerzahl') {
                     this.apiDataMitarbeiter = value
                  }
                  if (key === 'InfoText' || key === 'infotext' || key === 'infoText') {
                     this.apiDataInfoText = value
                  }
                  if (value.constructor === Object) {
                     for (const [key2, value2] of Object.entries(value)) {
                        if (key2 === 'Branche' || key2 === 'branche') {
                           this.apiDataBranche = value2
                        }
                        if (key2 === 'AnzahlMitarbeiter' || key2 === 'arbeitnehmerzahl') {
                           this.apiDataMitarbeiter = value2
                        }
                        if (key2 === 'InfoText' || key2 === 'infotext' || key2 === 'infoText') {
                           this.apiDataInfoText = value2
                        }
                     }
                  }
               }
               //  this.apiData = template
            }
         }
         console.log(json)
      },
      async loadKundeApi () {
         const compnayNumber = encodeURIComponent(this.customerInfo.customer_number)
         const response = await fetch(`/ai/get?Kundennummer=${compnayNumber}`, {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
               Authorization: `Basic ${window.btoa('KIDaten:KIDaten123.,')}`,
            },
         })
         if (!response.ok) {
            throw new Error(`Response status: ${response.status}`)
         }

         const json = await response.json()
         if (json.constructor === Array) {
            if (0 in json) {
               const item = json[0]
               //  let template = ''
               for (const [key, value] of Object.entries(item)) {
                  if (key === 'Branche') {
                     this.apiDataBranche = value
                  }
                  if (key === 'AnzahlMitarbeiter') {
                     this.apiDataMitarbeiter = value
                  }
                  if (key === 'InfoText') {
                     this.apiDataInfoText = value
                  }
               }
            }
         }
         console.log(json)
      },
      async saveKundeApi () {
         let adressSTring = ''
         const test = this.customerInfo?.branches[0]?.address
         if (test) {
            adressSTring += encodeURIComponent(`${test?.street} ${test?.house_number}, ${test?.zip} ${test?.city}`)
         }

         const firmenName = encodeURIComponent(this.customerInfo.name)
         const id = encodeURIComponent(this.customerInfo.customer_number)
         const creator = encodeURIComponent(this.customerInfo.creator.name)
         const apiDataBranche = encodeURIComponent(this.apiDataBranche)
         const apiDataMitarbeiter = encodeURIComponent(this.apiDataMitarbeiter)
         const infoText = encodeURIComponent(this.apiDataInfoText)
         const response = await fetch(`/ai/save?Kundennummer=${id}&Firma=${firmenName}&Ort=${adressSTring}&Branche=${apiDataBranche}&AnzahlMitarbeiter=${apiDataMitarbeiter}&Bearbeiter=${creator}&InfoText=${infoText}`, {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
               Authorization: `Basic ${window.btoa('KIDaten:KIDaten123.,')}`,
            },
         })
         if (!response.ok) {
            throw new Error(`Response status: ${response.status}`)
         }

         const json = await response.json()
         if (json.constructor === Array) {
            if (0 in json) {
               const item = json[0]
               //  let template = ''
               for (const [key, value] of Object.entries(item)) {
                  if (key === 'Branche') {
                     this.apiDataBranche = value
                  }
                  if (key === 'Arbeitnehmerzahl') {
                     this.apiDataMitarbeiter = value
                  }
                  if (value.constructor === Object) {
                     for (const [key2, value2] of Object.entries(value)) {
                        if (key2 === 'Branche') {
                           this.apiDataBranche = value2
                        }
                        if (key2 === 'Arbeitnehmerzahl') {
                           this.apiDataMitarbeiter = value2
                        }
                     }
                  } else {
                     //  template += key + ': ' + value + '\r\n'
                  }
               }
               //  this.apiData = template
            }
         }
         console.log(json)
      },
      hide_alert: function (event) {
         // `event` is the native DOM event
         window.setTimeout(() => {
            this.alert_succ = false
            this.alert_warn = false
         }, 2000)
      }
   },
}
</script>
